import { FunctionComponent } from 'react';
import { ImportFilesModelDashboard } from '.';

export const ImportFilesModelDashboardPage: FunctionComponent = () => {
	return <ImportFilesModelDashboard uploadMode={false} />;
};
